// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FullSizeLoader_wrapper__uBc8F","loader":"FullSizeLoader_loader__mOdSj"};